import React from 'react';
import { StyledVisuallyHiddenFocusable } from '@at/design-system-foundation';
import { dataAttrGUI, dataAttrTestId } from '@at/formatter-utils/lib/data-attr-utils/data-attr-utils';
export var SkipLinksComponent = function (_a) {
    var _b, _c;
    var show = _a.show;
    return show ? (React.createElement(React.Fragment, null,
        React.createElement(StyledVisuallyHiddenFocusable, (_b = { as: "a", href: "#content" }, _b[dataAttrGUI] = 'skip-to-content-gui', _b[dataAttrTestId] = 'skip-to-content-testid', _b.tabIndex = 0, _b), "Skip to content"),
        React.createElement(StyledVisuallyHiddenFocusable, (_c = { as: "a", href: "#footer" }, _c[dataAttrGUI] = 'skip-to-footer-gui', _c[dataAttrTestId] = 'skip-to-footer-testid', _c.tabIndex = 0, _c), "Skip to footer"))) : null;
};
export var SkipLinks = SkipLinksComponent;
